import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=1ff1e1f7&scoped=true"
import script from "./Hero.vue?vue&type=script&setup=true&lang=js"
export * from "./Hero.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Hero.vue?vue&type=style&index=0&id=1ff1e1f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff1e1f7",
  null
  
)

export default component.exports